export default "__VITE_ASSET__GC8Y9qyf__"